import { ConnectedRouter } from 'connected-react-router';
import { History } from 'history';
import * as React from 'react';
import { connect, Provider } from 'react-redux';
import { Store } from 'redux';
import { ApplicationState } from 'src/store';
import Routes from '../../routes/';
import Header from '../layout/Header/Header';
import Alert from '../utils/Alert/Alert';
import './App.scss';
import { PrintFooter } from '../utils/Print/PrintFooter';

interface Props {
  store: Store<ApplicationState>;
  history: History;
}

class App extends React.Component<Props> {
  public render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div className="App">
            <Header />
            <Routes />
            <Alert />
            <PrintFooter />
          </div>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default connect()(App);



// WEBPACK FOOTER //
// ./src/components/App/App.tsx